import { logger } from '@saaga/shared/utils/logger.util'
import { useCallback, useState } from 'react'
import { toast } from 'sonner'

const buildReturnUrl = (): string =>
  `${window.location.origin}${window.location.pathname}?checkout_completed=1&session_id={CHECKOUT_SESSION_ID}`

export interface UsePaymentMethodCheckoutReturn {
  initiateCheckout: () => Promise<void>
  isLoading: boolean
}

export const usePaymentMethodCheckout = (
  setupCheckout: (returnUrl: string) => Promise<{ clientSecret: string }>,
  onClientSecret: (clientSecret: string) => void
): UsePaymentMethodCheckoutReturn => {
  const [isLoading, setIsLoading] = useState(false)

  const initiateCheckout = useCallback(async (): Promise<void> => {
    setIsLoading(true)

    try {
      const response = await setupCheckout(buildReturnUrl())
      onClientSecret(response.clientSecret)
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to initiate card setup'
      toast.error(errorMessage)
      logger.error('Failed to setup payment method checkout', { error: err })
    } finally {
      setIsLoading(false)
    }
  }, [setupCheckout, onClientSecret])

  return {
    initiateCheckout,
    isLoading,
  }
}
